/** Privacy & cookie policy sections (EN / EL). Last updated shown via translations. */

export const privacySections = {
  en: [
    {
      id: "controller",
      title: "Who we are",
      paragraphs: [
        "Stellas Travel Agency («we», «us») operates this website to present travel packages and receive ticket and package inquiries.",
        "Data controller: Stellas Travel Agency, Ioanni Christidi 1, Ptolemaida 502 00, Greece.",
        "Contact for privacy matters: estelsach@gmail.com or +30 2463028796.",
      ],
    },
    {
      id: "collect",
      title: "What data we collect",
      paragraphs: [
        "When you submit a ticket request or a package inquiry, we collect the details you enter (for example name, phone number, optional email, travel dates, destinations, passenger counts, and notes).",
        "When you use the admin area, we process your login username and store an authentication token in your browser so you stay signed in.",
        "When you browse the public site, we do not use advertising or analytics cookies. We may store your cookie consent choice and language preference in your browser.",
        "Our contact page and footer show business contact details. Embedded content (such as Google Maps) may be loaded from third-party providers when you view those pages.",
      ],
    },
    {
      id: "purpose",
      title: "Why we use your data",
      paragraphs: [
        "To respond to your travel and ticket requests and to contact you about packages you asked about.",
        "To operate and secure the website and admin tools (package management, reviewing requests).",
        "To comply with legal obligations where applicable.",
      ],
    },
    {
      id: "legal",
      title: "Legal basis (GDPR)",
      paragraphs: [
        "Processing your inquiry data is based on steps taken at your request before a contract and on our legitimate interest in running a travel agency and answering customers.",
        "Admin login data is processed to protect access to our systems (legitimate interest / security).",
        "Where consent is required (for example non-essential cookies), we ask before storing them.",
      ],
    },
    {
      id: "storage",
      title: "Where data is stored",
      paragraphs: [
        "Inquiry and ticket data are stored in our secure database on our hosting provider (API server). Uploaded package images and PDFs are stored on the same server.",
        "The public website is hosted separately (for example Vercel). Data you submit is sent to our API over HTTPS.",
        "Admin session tokens are kept in your browser's local storage until you sign out or clear site data.",
      ],
    },
    {
      id: "retention",
      title: "How long we keep data",
      paragraphs: [
        "We keep ticket and package inquiries for as long as needed to handle your request and for reasonable business records, unless you ask us to delete them sooner or we are required to keep them longer by law.",
        "You can ask us to delete a specific inquiry; we will do so when we no longer need it for legal or business purposes.",
      ],
    },
    {
      id: "sharing",
      title: "Sharing with others",
      paragraphs: [
        "We do not sell your personal data. We share data only with service providers that host our website and API, and only as needed to run the service.",
        "If you follow links to social networks or external sites, their own privacy policies apply.",
      ],
    },
    {
      id: "rights",
      title: "Your rights",
      paragraphs: [
        "Under applicable law (including GDPR if you are in the EU/EEA), you may have the right to access, correct, delete, restrict, or object to processing of your data, and to lodge a complaint with a supervisory authority.",
        "To exercise your rights, contact us at estelsach@gmail.com. We will respond within a reasonable time.",
      ],
    },
    {
      id: "cookies",
      title: "Cookies and similar technologies",
      paragraphs: [
        "Essential storage: we save your cookie consent choice (local storage) so we do not show the banner again after you accept.",
        "Admin area: we store a login token in local storage so administrators remain signed in.",
        "We do not use third-party advertising or analytics cookies on this website at this time.",
        "You can clear cookies and local storage at any time in your browser settings; you may need to sign in to admin again and see the cookie banner again.",
      ],
    },
    {
      id: "changes",
      title: "Changes to this policy",
      paragraphs: [
        "We may update this policy when our practices or the law change. The «last updated» date at the top will change accordingly. Continued use of the site after changes means you accept the updated policy where permitted by law.",
      ],
    },
  ],
  el: [
    {
      id: "controller",
      title: "Ποιοι είμαστε",
      paragraphs: [
        "Το Stellas Travel Agency («εμείς») λειτουργεί αυτόν τον ιστότοπο για την παρουσίαση ταξιδιωτικών πακέτων και τη λήψη αιτημάτων εισιτηρίων και πακέτων.",
        "Υπεύθυνος επεξεργασίας: Stellas Travel Agency, Ιωάννη Χριστίδη 1, Πτολεμαΐδα 502 00, Ελλάδα.",
        "Επικοινωνία για θέματα απορρήτου: estelsach@gmail.com ή +30 2463028796.",
      ],
    },
    {
      id: "collect",
      title: "Τι δεδομένα συλλέγουμε",
      paragraphs: [
        "Όταν υποβάλλετε αίτημα εισιτηρίου ή αίτημα πακέτου, συλλέγουμε τα στοιχεία που συμπληρώνετε (π.χ. όνομα, τηλέφωνο, προαιρετικό email, ημερομηνίες ταξιδιού, προορισμούς, αριθμό επιβατών, σημειώσεις).",
        "Όταν χρησιμοποιείτε τη διαχείριση (admin), επεξεργαζόμαστε το όνομα χρήστη σύνδεσης και αποθηκεύουμε διακριτικό ταυτοποίησης στο πρόγραμμα περιήγησής σας ώστε να παραμένετε συνδεδεμένοι.",
        "Κατά την περιήγηση στον δημόσιο ιστότοπο δεν χρησιμοποιούμε cookies διαφήμισης ή ανάλυσης. Μπορούμε να αποθηκεύουμε την επιλογή σας για cookies και την προτίμηση γλώσσας στο πρόγραμμα περιήγησης.",
        "Στο footer εμφανίζονται στοιχεία επικοινωνίας. Ενσωματωμένο περιεχόμενο (π.χ. Google Maps) μπορεί να φορτώνεται από τρίτους όταν βλέπετε τις σχετικές σελίδες.",
      ],
    },
    {
      id: "purpose",
      title: "Γιατί χρησιμοποιούμε τα δεδομένα",
      paragraphs: [
        "Για να απαντήσουμε σε αιτήματα ταξιδιού και εισιτηρίων και να επικοινωνήσουμε μαζί σας για πακέτα που ζητήσατε.",
        "Για τη λειτουργία και την ασφάλεια του ιστότοπου και των εργαλείων διαχείρισης (πακέτα, αιτήματα).",
        "Για συμμόρφωση με νομικές υποχρεώσεις όπου ισχύουν.",
      ],
    },
    {
      id: "legal",
      title: "Νομική βάση (GDPR)",
      paragraphs: [
        "Η επεξεργασία αιτημάτων βασίζεται σε μέτρα πριν από σύμβαση κατόπιν αιτήματός σας και στο έννομο συμφέρον μας για τη λειτουργία του ταξιδιωτικού γραφείου.",
        "Τα δεδομένα σύνδεσης διαχειριστή επεξεργάζονται για την προστασία πρόσβασης (έννομο συμφέρον / ασφάλεια).",
        "Όπου απαιτείται συγκατάθεση (π.χ. μη απαραίτητα cookies), τη ζητάμε πριν την αποθήκευση.",
      ],
    },
    {
      id: "storage",
      title: "Πού αποθηκεύονται τα δεδομένα",
      paragraphs: [
        "Τα αιτήματα αποθηκεύονται σε ασφαλή βάση δεδομένων στον πάροχο φιλοξενίας API. Μεταφορτωμένες εικόνες και PDF πακέτων αποθηκεύονται στον ίδιο διακομιστή.",
        "Ο δημόσιος ιστότοπος φιλοξενείται χωριστά (π.χ. Vercel). Τα δεδομένα που υποβάλλετε αποστέλλονται στο API μέσω HTTPS.",
        "Τα διακριτικά σύνδεσης διαχειριστή διατηρούνται στο local storage του προγράμματος περιήγησης μέχρι να αποσυνδεθείτε ή να διαγράψετε δεδομένα ιστότοπου.",
      ],
    },
    {
      id: "retention",
      title: "Διάρκεια διατήρησης",
      paragraphs: [
        "Διατηρούμε αιτήματα για όσο χρειάζεται για την εξυπηρέτησή σας και για εύλογες επιχειρηματικές ανάγκες, εκτός αν ζητήσετε νωρίτερα διαγραφή ή απαιτείται μεγαλύτερη διατήρηση από τον νόμο.",
        "Μπορείτε να ζητήσετε διαγραφή συγκεκριμένου αιτήματος· θα το πράξουμε όταν δεν το απαιτεί πλέον ο νόμος ή η επιχείρηση.",
      ],
    },
    {
      id: "sharing",
      title: "Κοινοποίηση σε τρίτους",
      paragraphs: [
        "Δεν πωλούμε προσωπικά δεδομένα. Κοινοποιούμε μόνο σε παρόχους φιλοξενίας ιστότοπου και API, στο βαθμό που απαιτείται για τη λειτουργία.",
        "Αν ακολουθήσετε συνδέσμους σε κοινωνικά δίκτυα ή εξωτερικούς ιστότοπους, ισχύουν οι δικές τους πολιτικές.",
      ],
    },
    {
      id: "rights",
      title: "Τα δικαιώματά σας",
      paragraphs: [
        "Σύμφωνα με την ισχύουσα νομοθεσία (συμπεριλαμβανομένου GDPR στην ΕΕ/ΕΟΧ), μπορεί να έχετε δικαίωμα πρόσβασης, διόρθωσης, διαγραφής, περιορισμού ή εναντίωσης, και καταγγελίας στην αρχή προστασίας δεδομένων.",
        "Για άσκηση δικαιωμάτων: estelsach@gmail.com. Θα απαντήσουμε εντός εύλογου χρόνου.",
      ],
    },
    {
      id: "cookies",
      title: "Cookies και παρόμοια τεχνολογία",
      paragraphs: [
        "Απαραίτητη αποθήκευση: αποθηκεύουμε την αποδοχή cookies (local storage) ώστε να μην εμφανίζεται ξανά το banner.",
        "Διαχείριση: αποθηκεύουμε διακριτικό σύνδεσης στο local storage για διαχειριστές.",
        "Δεν χρησιμοποιούμε cookies διαφήμισης ή ανάλυσης τρίτων στον ιστότοπο αυτή τη στιγμή.",
        "Μπορείτε να διαγράψετε cookies και local storage από τις ρυθμίσεις του προγράμματος περιήγησης· ενδέχεται να χρειαστεί νέα σύνδεση στο admin και να εμφανιστεί ξανά το banner.",
      ],
    },
    {
      id: "changes",
      title: "Αλλαγές στην πολιτική",
      paragraphs: [
        "Μπορούμε να ενημερώνουμε αυτή την πολιτική όταν αλλάζουν οι πρακτικές ή ο νόμος. Η ημερομηνία «τελευταία ενημέρωση» θα αλλάζει ανάλογα.",
      ],
    },
  ],
};

export const COOKIE_CONSENT_KEY = "stella_cookie_consent";
